// src/redux/store.js
// import { configureStore } from '@reduxjs/toolkit';
// import userReducer from '../../src/Auth/Slice/LoginSlice';

// const store = configureStore({
//   reducer: {
//     user: userReducer,
//   },
// });

// export default store;


// import { configureStore } from '@reduxjs/toolkit';
// import storage from 'redux-persist/lib/storage'; // Default: localStorage for web
// import { persistReducer, persistStore } from 'redux-persist';
// import { combineReducers } from 'redux';
// import LoginSlice from '../Auth/Slice/LoginSlice';

// // Persist Configuration
// const persistConfig = {
//   key: 'root',
//   storage, // This uses localStorage to persist the state
// };

// // Combine reducers
// const rootReducer = combineReducers({
//   user: LoginSlice, // Add other slices here if needed
// });

// // Wrap the root reducer with persistReducer
// const persistedReducer = persistReducer(persistConfig, rootReducer);

// // Create Redux store
// const store = configureStore({
//   reducer: persistedReducer,
// });

// // Export persistor for usage in App
// export const persistor = persistStore(store);

// export default store;


// import { configureStore } from '@reduxjs/toolkit';
// import storage from 'redux-persist/lib/storage'; // Uses localStorage
// import { persistReducer, persistStore } from 'redux-persist';
// import { combineReducers } from 'redux';
// import LoginSlice from './Slice/LoginSlice';

// // Configure redux-persist
// const persistConfig = {
//   key: 'root',
//   storage,
// };

// const rootReducer = combineReducers({
//   user: LoginSlice, // Add other slices here if needed
// });

// // Wrap the rootReducer with persistReducer
// const persistedReducer = persistReducer(persistConfig, rootReducer);

// // Create and export the Redux store
// const store = configureStore({
//   reducer: persistedReducer,
// });

// // Export persistor for use with PersistGate
// export const persistor = persistStore(store);

// export default store;


import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import LoginSlice from "./Slice/LoginSlice";
import locationReducer from "../../src/Redux/Slice/locationSlice"; // Import location reducer

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: LoginSlice,
  location: locationReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export default store;


